import { render, staticRenderFns } from "./ViewSalesDeliveryComponent.vue?vue&type=template&id=7f7485ac"
import script from "./ViewSalesDeliveryComponent.vue?vue&type=script&lang=js"
export * from "./ViewSalesDeliveryComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports